import { useMutation } from "react-query";
import { useDispatch } from "react-redux";

import { getErrorMessage } from "helpers";
import { feeTemplateService } from "services";
import { uiActions } from "store";
import { ErrorResponse } from "types";

type MutationProps = {
	companyId: string;
	type: string;
	templateName: string;
};

const useCheckFeeTemplateNameMutation = (onSuccess?: Function) => {
	const dispatch = useDispatch();

	return useMutation(
		({ companyId, type, templateName }: MutationProps) => {
			return feeTemplateService.isTemplateNameUnique(
				companyId,
				type,
				templateName,
			);
		},
		{
			onSuccess() {
				onSuccess?.();
			},
			onError(error: ErrorResponse) {
				dispatch(
					uiActions.showErrorNotification({
						title: getErrorMessage(error),
					}),
				);
			},
		},
	);
};

export default useCheckFeeTemplateNameMutation;
